import React from "react";
import { motion } from "framer-motion";

// ===============================================================
// ProBank — Premium Splash Loader
//
// Logo in a circular gold frame, soft breathing glow, a fine
// gold line drawing beneath. Calm and confident, no spinner.
// Paired with a guaranteed 2-second minimum in App.js.
// ===============================================================

export default function LoadingOverlay() {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{
        background: "#0B0D10",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
      }}
    >
      {/* Ambient gold glow behind the circle */}
      <motion.div
        className="absolute w-[340px] h-[340px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(184,147,95,0.14) 0%, transparent 62%)",
        }}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.1, ease: "easeOut" }}
      />

      <div className="relative flex flex-col items-center">
        {/* Circular logo frame — fades up gently */}
        <motion.div
          initial={{ opacity: 0, y: 14, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <motion.div
            className="rounded-full flex items-center justify-center overflow-hidden"
            style={{
              width: 96,
              height: 96,
              background: "#14171C",
              border: "1.5px solid rgba(184,147,95,0.5)",
              boxShadow:
                "0 0 32px rgba(184,147,95,0.25), inset 0 0 20px rgba(184,147,95,0.08)",
            }}
            animate={{ scale: [1, 1.035, 1] }}
            transition={{
              duration: 2.4,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 0.7,
            }}
          >
            <img
              src="/banklogo.png"
              alt="ProBank"
              className="w-14 h-14 object-contain"
            />
          </motion.div>
        </motion.div>

        {/* Fine gold line — draws itself under the circle */}
        <motion.div
          className="mt-8 h-px rounded-full"
          style={{
            background:
              "linear-gradient(90deg, transparent, #C7A472, transparent)",
          }}
          initial={{ width: 0, opacity: 0 }}
          animate={{ width: 96, opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.35, ease: "easeOut" }}
        />

        {/* Brand wordmark */}
        <motion.p
          className="mt-5 text-[12px] tracking-[0.35em] uppercase"
          style={{ color: "#8B8D93" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.55 }}
        >
          ProBank
        </motion.p>
      </div>
    </div>
  );
}
